import { configureStore } from '@reduxjs/toolkit'
import dashboardReducer from './slices/dashboardSlice'
import dataReducer from './slices/dataSlice'
import assetsReducer from './slices/assetsSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    data: dataReducer,
    assets: assetsReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch